import { HomeOutlined, LocalOffer, Storefront } from '@mui/icons-material';
import { IRoute } from '../interfaces';
import Landing from '../pages/Landing';
import DealerLanding from '../pages/DealerLanding';
import DealerOffer from '../pages/DealerOffer';

export const routes: Array<IRoute> = [
  {
    key: 'main-landing-route',
    title: 'DealerScout — Dealers compete for your business',
    path: '/',
    enabled: true,
    component: Landing,
    icon: HomeOutlined,
    menu: false,
    protected: false,
  },
  {
    key: 'dealer-landing-route',
    title: 'For Dealers',
    path: '/dealer',
    enabled: true,
    component: DealerLanding,
    icon: Storefront,
    menu: false,
    protected: false,
  },
  {
    // Dealers land here from their email link; the token is the credential.
    key: 'dealer-offer-route',
    title: 'Submit Offer',
    path: '/offer/:token',
    enabled: true,
    component: DealerOffer,
    icon: LocalOffer,
    menu: false,
    protected: false,
  },
];
